import { useInstance } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { useReceive } from '../../hooks/useReceive';
export function useShowPassword() {
  var instance = useInstance();
  var isShow = useState(false);
  var type = useState(undefined);
  var showIcon = useState(false);
  instance.on('$receive:type', function (_type) {
    type.set(_type);
  });
  useReceive(['type', 'showPassword'], function () {
    var _instance$get = instance.get(),
      showPassword = _instance$get.showPassword,
      type = _instance$get.type;
    showIcon.set(type === 'password' && !!showPassword);
  });
  function toggleShow() {
    isShow.set(!isShow.value);
    type.set(isShow.value ? 'text' : 'password');
  }
  return {
    isShow: isShow,
    type: type,
    toggleShow: toggleShow,
    showIcon: showIcon
  };
}